import { jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import { SLIDER_NORM_WIDTH, SLIDER_SMALL_WIDTH } from "../constants/constants";
import UncontrolledSliderWithPlusMinusBtns from "../helperComponents/UncontrolledSliderWithPlusMinusBtns";
export function RotateCircularViewSlider({
  setRotationRadians,
  zoomLevel,
  maxZoomLevel,
  bindOutsideChangeHelper,
  smallSlider,
  editorName
}) {
  const escapedEditorName = editorName && typeof CSS !== "undefined" && CSS.escape ? CSS.escape(editorName) : editorName;
  const mainSelector = editorName ? `.veEditor.${escapedEditorName}` : ".veEditor";
  const target = React.useRef();
  const svgEleRef = React.useRef();
  useEffect(() => {
    const svgEle = document.querySelector(mainSelector)?.querySelector(".veCircularView .circularViewSvg");
    svgEleRef.current = svgEle;
  }, [editorName, mainSelector]);
  const showLabelsDebounced = useDebouncedCallback(
    (el) => {
      try {
        if (el) el.classList.remove("veHideLabels");
        else {
          console.error(`whoops we shouldn't be here`);
        }
      } catch (e) {
        console.error(`error 92hf290fasd:`, e);
      }
    },
    // delay in ms
    300,
    { leading: true }
  );
  const stepSize = Math.min(
    3,
    3 / (zoomLevel / 2) * (maxZoomLevel / (zoomLevel / 2))
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        zIndex: 900,
        position: "absolute"
      },
      children: /* @__PURE__ */ jsx(
        UncontrolledSliderWithPlusMinusBtns,
        {
          bindOutsideChangeHelper,
          onChange: (_val) => {
            const val = 360 - _val;
            if (!svgEleRef.current) {
              svgEleRef.current = document.querySelector(mainSelector)?.querySelector(".veCircularView .circularViewSvg");
            }
            const el = svgEleRef.current;
            if (!el) return;
            const innerEl = el?.querySelector("g");
            innerEl.style.transform = `rotate(${val}deg)`;
            setRotationRadians(val * Math.PI / 180);
            if (zoomLevel <= 1) {
              el.classList.add("veHideLabels");
            }
            showLabelsDebounced(el);
          },
          smallSlider: true,
          passedRef: target,
          showTrackFill: false,
          leftIcon: "arrow-left",
          rightIcon: "arrow-right",
          title: "Rotate",
          style: {
            paddingTop: "4px",
            width: smallSlider ? SLIDER_SMALL_WIDTH : SLIDER_NORM_WIDTH
          },
          className: "veRotateCircularSlider ove-slider",
          labelRenderer: false,
          stepSize,
          justUpdateInitialValOnce: true,
          max: 360,
          min: 0
        }
      )
    }
  );
}
